var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppIconLeckage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 629 629",
    enableBackground: "new 0 0 629 629",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M504.058,628.858H124.942c-68.925,0-124.8-55.875-124.8-124.8V124.942c0-68.925,55.875-124.8,124.8-124.8 h379.115c68.925,0,124.8,55.875,124.8,124.8v379.115C628.858,572.983,572.983,628.858,504.058,628.858z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#9F186E",
    d: "M504.058,628.858H124.942c-68.925,0-124.8-55.875-124.8-124.8V124.942 c0-68.925,55.875-124.8,124.8-124.8h379.115c68.925,0,124.8,55.875,124.8,124.8v379.115 C628.858,572.983,572.983,628.858,504.058,628.858z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M504.058,628.858H124.942c-68.925,0-124.8-55.875-124.8-124.8V124.942c0-68.925,55.875-124.8,124.8-124.8 h379.115c68.925,0,124.8,55.875,124.8,124.8v379.115C628.858,572.983,572.983,628.858,504.058,628.858z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#A32879",
    points: "-167.337,420.943 -341.252,634.467 6.472,634.467  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9F186E",
    points: "-167.337,420.943 6.472,207.418 -341.252,207.418  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A6548B",
    points: "-167.337,-6.106 -341.252,207.418 6.472,207.418  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#74286E",
    points: "6.472,634.467 180.388,420.943 -167.337,420.943  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7E227D",
    points: "6.472,207.418 -167.337,420.943 180.388,420.943  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#803C7B",
    points: "6.472,207.418 180.388,-6.106 -167.337,-6.106  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#441941",
    points: "180.388,420.943 6.472,634.467 354.303,634.467  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A32879",
    points: "180.388,420.943 354.303,207.418 6.472,207.418  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#521F54",
    points: "180.388,-6.106 6.472,207.418 354.303,207.418  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5B2764",
    points: "354.303,634.467 528.219,420.943 180.388,420.943  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8A266E",
    points: "354.303,207.418 180.388,420.943 528.219,420.943  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#54266E",
    points: "354.303,207.418 528.219,-6.106 180.388,-6.106  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#54266E",
    points: "528.219,420.943 354.303,634.467 702.028,634.467  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#54266E",
    points: "528.219,420.943 702.028,207.418 354.303,207.418  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#530067",
    points: "528.219,-6.106 354.303,207.418 702.028,207.418  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#441941",
    points: "702.028,634.467 875.943,420.943 528.219,420.943  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#74286E",
    points: "702.028,207.418 528.219,420.943 875.943,420.943  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5B2764",
    points: "702.028,207.418 875.943,-6.106 528.219,-6.106  "
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M165.984,372.226l22.629-137.813l23.091,99.208c2.288,10.16,16.416,11.315,20.257,1.511l20.929-53.488 l12.028,24.456c0,0,3.926,6.591,10.454,6.591H304.3V291.7h-22.042l-20.068-42.236c-3.758-8.712-16.185-8.523-19.649,0.336 l-17.738,45.343L197.451,174.04c-1.239-5.563-5.773-8.292-10.286-8.292c-4.807,0-9.593,3.044-10.538,8.922l-22.692,139.912 l-23.196-86.151c-2.582-10.286-17.088-10.895-20.404-0.672L93.099,291.7H73.388v20.656h28.066c3.842,0,7.998-3.086,9.09-6.78 l9.782-31.614l24.918,99.145C148.035,384.296,164.136,383.561,165.984,372.226z M577.197,429.954l-59.428-59.45 c10.958-16.584,17.444-36.421,17.444-57.812c0-57.959-46.98-104.96-104.96-104.96s-104.96,47.001-104.96,104.96 s46.98,104.96,104.96,104.96c21.391,0,41.228-6.487,57.833-17.465l59.428,59.45L577.197,429.954z M367.277,312.692 c0-34.721,28.255-62.976,62.976-62.976s62.976,28.255,62.976,62.976s-28.255,62.976-62.976,62.976S367.277,347.413,367.277,312.692 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconLeckage);
export default __webpack_public_path__ + "static/media/app_icon_leckage.ae164f1eb2286ec753f3e3531aef92f3.svg";
export { ForwardRef as ReactComponent };